import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Calendar, BookOpen, Award, ChevronRight } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';

const Education = () => {
  const { educationData } = useAppContext();

  return (
    <section id="education" className="py-20 bg-secondary/5 relative">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12 text-center"
        >
          <h2 className="text-3xl font-bold mb-2 terminal-text">
            <span className="text-primary">{'>'}</span> Education
          </h2>
          <div className="w-20 h-1 bg-primary mx-auto"></div>
        </motion.div>

        <div className="space-y-8 max-w-4xl mx-auto">
          {educationData.map((edu, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="bg-background/80 border border-border/50 rounded-lg overflow-hidden shadow-lg hover:border-primary/30 transition-all duration-300 card-hover"
            >
              <div className="bg-primary/10 p-4 border-b border-border/50">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center mr-4">
                    <GraduationCap className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold terminal-text gradient-text">
                      {edu.degree}
                    </h3>
                    <div className="flex items-center text-foreground/80">
                      <span>{edu.institution}</span>
                      <span className="mx-2">•</span>
                      <span className="flex items-center text-sm text-foreground/60">
                        <Calendar className="h-4 w-4 mr-1" />
                        {edu.duration}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <p className="mb-6 text-foreground/80">{edu.description}</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-card/30 p-4 rounded-lg border border-border/30">
                    <div className="flex items-center mb-3">
                      <BookOpen className="h-5 w-5 text-primary mr-2" />
                      <h4 className="font-medium">Key Courses</h4>
                    </div>
                    <ul className="space-y-2">
                      {edu.courses.map((course, i) => (
                        <li key={i} className="flex items-start">
                          <ChevronRight className="h-4 w-4 text-primary mt-1 mr-2 flex-shrink-0" />
                          <span className="text-sm text-foreground/80">{course}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-card/30 p-4 rounded-lg border border-border/30">
                    <div className="flex items-center mb-3">
                      <Award className="h-5 w-5 text-primary mr-2" />
                      <h4 className="font-medium">Achievements</h4>
                    </div>
                    <ul className="space-y-2">
                      {edu.achievements.map((achievement, i) => (
                        <li key={i} className="flex items-start">
                          <ChevronRight className="h-4 w-4 text-primary mt-1 mr-2 flex-shrink-0" />
                          <span className="text-sm text-foreground/80">{achievement}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
